import { Nav, Platform, App, MenuController } from 'ionic-angular';
import { trigger,state, style, transition, animate, query, stagger } from '@angular/animations';
import { Component, ViewChild } from '@angular/core';
import { StatusBar }            from '@ionic-native/status-bar';
import { SplashScreen }         from '@ionic-native/splash-screen';

import { DataServiceProvider }  from './../providers/data-service/data-service';
import { SplitPaneProvider }    from './../providers/split-pane/split-pane';

import { PopoverController }   from 'ionic-angular';

@Component({
  templateUrl: 'app.html',
  animations: [
    trigger('animate', [
      state('in', style({ transform: 'translateY(0)', opacity: 0 })),
      //Enter
      transition('* => *', [
        style({
          transform: 'translateY(100%)',
          opacity: 1
        }),
        animate('300ms ease-in')
      ]),
      //Leave
      transition('* => void',
      animate('300ms ease-out',
      style({
          transform: 'translateY(-100%)',
          opacity: 0
        })
      )),
    ]),
    trigger('pAnimation', [
      transition('* => *', [
        query('div, p, img',
        style({ transform: 'translateY(-10%)', opacity: 0})),
        query('div, p, img',
          stagger('100ms', [
            animate('900ms',
            style({ transform: 'translateY(0)', opacity: 1}))
        ]))
      ])
    ])
  ]
})

export class MyApp {

  @ViewChild(Nav) nav: Nav;

  rootPage: any = 'LoginPage';

  responseData : any;
  menus        = [];

     userData = { user_mail: "", user_name: "", user_imagem: "" };
  userDetails = { user_mail: "", user_name: "", user_imagem: "" };

   conectado: any;
  mostraNome: boolean;

  public itemExpandHeight : number = 100;

  pages  : Array<{ title: string, component: any, icon: any, expanded: any }>;

  //pages: Array<{title: string, component: any}>;

  constructor(
                public app : App,
                public platform : Platform,
                public statusBar : StatusBar,
                public splashScreen : SplashScreen,
                public splitPane : SplitPaneProvider,
                public popoverCtrl : PopoverController,
                public dataServiceProvider : DataServiceProvider,
                public menu : MenuController
              )
              {

                this.initializeApp();

                const data = JSON.parse(localStorage.getItem('userLogin'));

                if(data){

                  this.userDetails = data;
                  this.userData.user_name = this.userDetails.user_name;

                  console.log('Bem-vindo ' + this.userData.user_name);

                  this.dataServiceProvider.getMenu()
                      .subscribe((data)=> {

                        this.menus = data;

                      });

              }

  }

  initializeApp() {

    this.platform.ready().then(() => {

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // to check if we have permission

    });

  }

  presentPopover(event) {
    let popover = this.popoverCtrl.create('PopOverPage', { showBackdrop: true, cssClass: 'popOver' });
    popover.present({
      ev: event
    });
  }

  home() {
    this.nav.setRoot('HomePage');
  }

  concorrencia(){
    this.nav.setRoot('ConcorrenciasPage');
  }

  checklistComparativo(){
    this.nav.setRoot('ChecklistPage');
  }

  novosKits(){
    this.nav.setRoot('NovosKitsPage');
  }

  shoppingPreco(){
    this.nav.setRoot('ShoppingPrecosPage');
  }

  geralVendas(){
    this.nav.setRoot('GeralVendasPage');
  }

  novosNegocios(){
    this.nav.setRoot('NovosNegociosPage');
  }

  relacao(){
    this.nav.setRoot('RelacaoPage');
  }

  vinculadosPerdendo(){
    this.nav.setRoot('RelatorioAnunciosVinculadosPerdendoPage');
  }

  uso(){
    this.nav.setRoot('UsoPage');
  }

  logout() {
    localStorage.clear();
    this.nav.setRoot('LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts